"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _components = require("@engaging-tech/components");
var _routing = require("@engaging-tech/routing");
var _NavItems = _interopRequireDefault(require("./NavItems"));
var _AuxillaryLinks = _interopRequireDefault(require("./AuxillaryLinks"));
var _useNavContext2 = _interopRequireDefault(require("../../hooks/useNavContext"));
var _NavUserDetails = _interopRequireDefault(require("./NavUserDetails"));
var _PremiumLink = _interopRequireDefault(require("../desktop/PremiumLink"));
var _AccountLinks = _interopRequireDefault(require("./AccountLinks"));
var _Cart = _interopRequireDefault(require("../desktop/Cart"));
var Wrapper = (0, _styledComponents["default"])(_components.MotionBox).withConfig({
  displayName: "Drawer__Wrapper",
  componentId: "sc-vb1ca5-0"
})(["align-self:flex-start;z-index:1001;overflow:auto;"]);
var BottomBorderedFlex = (0, _styledComponents["default"])(_components.Flex).withConfig({
  displayName: "Drawer__BottomBorderedFlex",
  componentId: "sc-vb1ca5-1"
})(["position:sticky;top:0px;z-index:40;border-bottom:1px solid ", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary[1];
});
var Overlay = (0, _styledComponents["default"])(_components.MotionFlex).withConfig({
  displayName: "Drawer__Overlay",
  componentId: "sc-vb1ca5-2"
})(["position:fixed;z-index:1000;top:0;left:0;width:100%;height:100%;flex-direction:column;justify-content:center;align-items:center;"]);
var overlayVariants = {
  hidden: {
    opacity: 0,
    display: "none",
    transition: {
      delay: 0.1,
      ease: "easeInOut",
      duration: 0.3,
      display: {
        delay: 0.4
      }
    }
  },
  visible: {
    opacity: 1,
    display: "initial",
    transition: {
      duration: 0.3,
      ease: "easeInOut"
    }
  }
};
var drawVariants = {
  hidden: {
    x: -400,
    transition: {
      ease: "easeIn",
      duration: 0.3
    }
  },
  visible: {
    x: 0,
    transition: {
      delay: 0.1,
      ease: "easeOut",
      duration: 0.3
    }
  }
};

/**
 * The expandable side panel that is visible when a user taps
 * on the burger menu. Main nav routes & auxillary routes
 * are displayed within this drawer. This component is **mobile-only**.
 * @package
 */
var Drawer = function Drawer(_ref2) {
  var SiteLogo = _ref2.siteLogo,
    linkTo = _ref2.linkTo;
  var _useNavContext = (0, _useNavContext2["default"])(),
    cartShow = _useNavContext.cartShow,
    Content = _useNavContext.content,
    ExtraNavComponent = _useNavContext.ExtraNavComponent,
    drawerIsOpen = _useNavContext.drawerIsOpen,
    toggleDrawer = _useNavContext.toggleDrawer;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, drawerIsOpen && /*#__PURE__*/_react["default"].createElement(_components.Utils.DisableScroll, null), /*#__PURE__*/_react["default"].createElement(Overlay, {
    onTap: function onTap(e) {
      if (e.target.id === "drawer-overlay") {
        toggleDrawer();
      }
    },
    key: "drawer-overlay",
    variants: overlayVariants,
    initial: "hidden",
    animate: drawerIsOpen ? "visible" : "hidden",
    bg: "dark.3",
    id: "drawer-overlay"
  }, /*#__PURE__*/_react["default"].createElement(Wrapper, {
    key: "drawer-container",
    bg: "light.0",
    height: "100%",
    width: 4 / 5,
    maxWidth: 340,
    variants: drawVariants,
    initial: "hidden",
    animate: drawerIsOpen ? "visible" : "hidden",
    onTap: function onTap(e) {
      e.stopPropagation();
    }
  }, /*#__PURE__*/_react["default"].createElement(BottomBorderedFlex, {
    height: "auto",
    width: 1 / 1,
    flexDirection: "column",
    pb: 2,
    pl: 2,
    bg: "light.0"
  }, SiteLogo && /*#__PURE__*/_react["default"].createElement(_routing.Link, {
    to: linkTo || "/"
  }, /*#__PURE__*/_react["default"].createElement(_components.Flex, {
    width: 1 / 1,
    height: 56,
    justifyContent: "space-between",
    alignItems: "center",
    pl: "8px"
  }, /*#__PURE__*/_react["default"].createElement(SiteLogo, null))), /*#__PURE__*/_react["default"].createElement(_components.Flex, {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    flexWrap: "wrap",
    alignContent: "center",
    mt: 2
  }, /*#__PURE__*/_react["default"].createElement(_NavUserDetails["default"], null), /*#__PURE__*/_react["default"].createElement(_components.Flex, {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    flexWrap: "wrap",
    alignContent: "center",
    mt: 2
  }, /*#__PURE__*/_react["default"].createElement(_AccountLinks["default"], null), cartShow ? /*#__PURE__*/_react["default"].createElement(_Cart["default"], null) : null))), Content && /*#__PURE__*/_react["default"].createElement(Content, null), /*#__PURE__*/_react["default"].createElement(_NavItems["default"], null), /*#__PURE__*/_react["default"].createElement(_AuxillaryLinks["default"], null), ExtraNavComponent && /*#__PURE__*/_react["default"].createElement(ExtraNavComponent, null), /*#__PURE__*/_react["default"].createElement(_PremiumLink["default"], {
    ml: 2
  }))));
};
var _default = exports["default"] = Drawer;